import { mapGetters } from "vuex";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";

export default {
  mixins: [dateFunctions],
  computed: {
    ...mapGetters([
      "getUserStats",
      "getDataPrivacy",
      "getTermsAndConditions",
      "getLicence"
    ]),
    limit() {
      let limit = {
        n: 0,
        nc1: 0,
        nc1a: 0,
        nf1: 0,
        nf1a: 0
      };
      // eslint-disable-next-line
      if (
        this.getLicence !== null &&
        this.getUserStats.rlic !== "Free" &&
        this.getUserStats.rlic !== "Unlimited"
      ) {
        limit.n = "L!";
        limit.nc1 = "L!";
        limit.nc1a = "L!";
        limit.nf1 = "L!";
        limit.nf1a = "L!";
        // eslint-disable-next-line
      } if (this.getLicence !== null && this.getUserStats.rlic === "Unlimited") {
        limit.n = "UL";
        limit.nc1 = "UL";
        limit.nc1a = "UL";
        limit.nf1 = "UL";
        limit.nf1a = "UL";
        // eslint-disable-next-line
      } else if (this.getLicence !== null && this.getUserStats.rlic === "Free") {
        limit.n = this.getLicence.freeUpdates;
        limit.nc1 = this.getLicence.freeCompanyCreate;
        limit.nc1a = this.getLicence.freeCompanyAccess;
        limit.nf1 = this.getLicence.freeFacilityCreate;
        limit.nf1a = this.getLicence.freeFacilityAccess;
      } else {
        limit.n = "L!";
        limit.nc1 = "L!";
        limit.nc1a = "L!";
        limit.nf1 = "L!";
        limit.nf1a = "L!";
      }
      return limit;
    },
    licenceOK() {
      let check = false;
      if (this.limit !== null) {
        let n = this.getUserStats.n;
        let nc1 = this.getUserStats.nc1;
        let nc1a = this.getUserStats.nc1a;
        let nf1 = this.getUserStats.nf1;
        let nf1a = this.getUserStats.nf1a;
        // eslint-disable-next-line
        if (this.limit.n === "UL" && this.licenceDateOK === true) {
          check = true;
        } else if (
          this.licenceDateOK === true &&
          this.limit.n > n &&
          this.limit.nc1 >= nc1 &&
          this.limit.nc1a >= nc1a &&
          this.limit.nf1 >= nf1 &&
          this.limit.nf1a >= nf1a
        ) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = true;
      }
      return check;
    },
    licenceOKCompanyNew() {
      let check = false;
      if (this.limit !== null) {
        let nc1 = this.getUserStats.nc1;
        // eslint-disable-next-line
        if (this.limit.n === "UL" && this.licenceDateOK === true) {
          check = true;
        } else if (this.limit.nc1 > nc1) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = true;
      }
      return check;
    },
    licenceOKCompanyAccess() {
      let check = false;
      if (this.limit !== null) {
        let nc1a = this.getUserStats.nc1a;
        // eslint-disable-next-line
        if (this.limit.n === "UL" && this.licenceDateOK === true) {
          check = true;
        } else if (this.limit.nc1a > nc1a) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = true;
      }
      return check;
    },
    licenceOKFacilityNew() {
      let check = false;
      if (this.limit !== null) {
        let nf1 = this.getUserStats.nf1;
        // eslint-disable-next-line
        if (this.limit.n === "UL" && this.licenceDateOK === true) {
          check = true;
        } else if (this.limit.nf1 > nf1) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = true;
      }
      return check;
    },
    licenceOKFacilityAccess() {
      let check = false;
      if (this.limit !== null) {
        let nf1a = this.getUserStats.nf1a;
        // eslint-disable-next-line
        if (this.limit.n === "UL" && this.licenceDateOK === true) {
          check = true;
        } else if (this.limit.nf1a > nf1a) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = true;
      }
      return check;
    },
    licenceDateOK() {
      let check = false;
      if (this.getUserStats !== null) {
        if (this.dateExpired(this.getUserStats.dexp) === false) {
          check = true;
        } else {
          check = false;
        }
      } else {
        check = false;
      }
      return check;
    }
  },
  methods: {
    checkUserLicenceOK() {
      let check = false;
      if (!this.licenceNotOK) {
        check = true;
      } else {
        check = false;
      }
      return check;
    }
  }
};
